import React from 'react';
import { Divider, Form, Checkbox, Label } from 'semantic-ui-react';
import { IdPropType, ModifierPropType, ModifierSetPropType } from '../../../services/proptypes';
import MenuUtil from '../../FoodMenu/utils/menu';
function getModifierSelectionText(min, max) {
  if (min === 0 && max === 0) return 'Select any';
  if (min > 0 && max === 0) return "Select a minimum of ".concat(min);
  if (min === 0 && max > 0) return "Select a maximum of ".concat(max);
  if (min > 0 && max > 0) {
    if (min === max) return "Select ".concat(min);
    return "Select ".concat(min, " to ").concat(max);
  }
  return '';
}
var ModifierSetSelection = function ModifierSetSelection(_ref) {
  var _id = _ref._id,
    name = _ref.name,
    allModifiers = _ref.allModifiers,
    modifierSets = _ref.modifierSets,
    onSelectModifier = _ref.onSelectModifier,
    isModifierSelected = _ref.isModifierSelected,
    isModifierDisabled = _ref.isModifierDisabled,
    checkoutDisabled = _ref.checkoutDisabled,
    _ref$showDivider = _ref.showDivider,
    showDivider = _ref$showDivider === void 0 ? true : _ref$showDivider;
  var modifierSet = MenuUtil.getModifierSetById(modifierSets, _id);
  var modifierSetModifierIds = modifierSet.modifiers;
  var modifierSetModifiers = MenuUtil.getModifierSetModifiers(modifierSetModifierIds, allModifiers, false);
  var minAllowed = modifierSet.minAllowed,
    maxAllowed = modifierSet.maxAllowed;
  var modifierSelectionDescription = getModifierSelectionText(minAllowed, maxAllowed);
  return modifierSetModifiers.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "item-cart-modifier-set-selection"
  }, showDivider && /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement("div", {
    className: "modifier-set-selection-header"
  }, /*#__PURE__*/React.createElement("h5", null, name.toUpperCase()), minAllowed > 0 ? /*#__PURE__*/React.createElement(Label, {
    color: "blue"
  }, "REQUIRED") : /*#__PURE__*/React.createElement(Label, {
    color: "blue"
  }, "OPTIONAL")), modifierSelectionDescription && /*#__PURE__*/React.createElement("div", {
    className: "modifier-set-selection-description"
  }, modifierSelectionDescription), /*#__PURE__*/React.createElement(Form, null, modifierSetModifiers.map(function (modifier) {
    var modifierId = modifier._id,
      modifierName = modifier.name,
      price = modifier.price;
    return /*#__PURE__*/React.createElement("div", {
      className: "modifier-set-selection-checkbox",
      key: modifierName
    }, /*#__PURE__*/React.createElement(Form.Field, null, /*#__PURE__*/React.createElement(Checkbox, {
      label: modifierName,
      name: "modifier",
      checked: isModifierSelected(modifierId),
      onChange: function onChange() {
        return onSelectModifier(modifier, modifierSet);
      },
      disabled: checkoutDisabled || isModifierDisabled(modifierSet, modifierId)
    })), /*#__PURE__*/React.createElement("div", null, price && +price !== 0 ? "$".concat((+price).toFixed(2)) : '-'));
  })));
};
ModifierSetSelection.defaultProps = {
  allModifiers: [],
  checkoutDisabled: false,
  showDivider: true
};
export default ModifierSetSelection;